export default "__VITE_ASSET__2e2b3be8__"